import { render, staticRenderFns } from "./BuildingAppRelation.vue?vue&type=template&id=07b64d12&lang=pug&"
import script from "./BuildingAppRelation.vue?vue&type=script&lang=ts&"
export * from "./BuildingAppRelation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports